import React from "react";
import { Box, Grid, Switch, Typography } from "@mui/material";
import { MobileCard } from "@ui/components/card";
import { IconText } from "@ui/components/info/IconText";
import { SMenuTrigger } from "@ui/components/menu/SMenu";
import { useTranslation } from "react-i18next";
import { formatUtcToLocalDateTimeString } from "@application/common/helpers/date-util";
import { between } from "@ui/components/style/style";
import { WifiSquare } from "iconsax-react";
export const UserCard = ({ row, onClick, onMenuClick, onToggleActive, canEdit, isCurrentUser, }) => {
    var _a, _b, _c, _d, _e;
    const { t } = useTranslation(["common"]);
    const roleNames = row.roleNames || [];
    const roleDisplay = roleNames.length > 0 ? roleNames.join(", ") : t("common:status.noRole");
    const lastVisit = row.lastLoginAt
        ? formatUtcToLocalDateTimeString(row.lastLoginAt, false)
        : t("common:actions.never");
    return (React.createElement(MobileCard, { onClick: onClick },
        React.createElement(Box, { sx: Object.assign(Object.assign({}, between), { gap: 1 }) },
            React.createElement(Box, { sx: { minWidth: 0 } },
                React.createElement(Typography, { variant: "subtitle2", noWrap: true }, `${row.firstName} ${row.lastName}`),
                React.createElement(Typography, { variant: "body2", color: "text.secondary", noWrap: true }, row.email)),
            React.createElement(SMenuTrigger, { onClick: (event) => {
                    event.stopPropagation();
                    onMenuClick(event, row.id);
                }, size: "medium" })),
        React.createElement(Grid, { container: true, spacing: 2 },
            React.createElement(Grid, { size: 6 },
                React.createElement(IconText, { customIcon: React.createElement(WifiSquare, { size: 24, color: "#454F5B" }), text: `${(_e = (_d = (_b = (_a = row.assignedAccessPoints) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : (_c = row.accessPoints) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : row.accessPointCount) !== null && _e !== void 0 ? _e : 0} ${t("common:grid.accessPoints")}` })),
            React.createElement(Grid, { size: 6 },
                React.createElement(IconText, { icon: "solar:user-linear", text: roleDisplay }))),
        React.createElement(Box, { sx: Object.assign(Object.assign({}, between), { gap: 1 }) },
            React.createElement(IconText, { icon: "solar:calendar-linear", text: `${t("common:grid.lastVisit")} ${lastVisit}` }),
            React.createElement(Switch, { checked: row.isActive, onChange: () => onToggleActive(row), onClick: (e) => e.stopPropagation(), disabled: isCurrentUser || !canEdit, size: "small" }))));
};
